import {
    LOCAL_STORAGE_KEYS,
    INTERFACE_PANEL_TRIGGERS,
    INFOTABLE_HEIGHT_PERC,
    INFOTABLE_WIDTH_PERC
} from '../../../../constants';
import { setFavicon } from '../../../../services/utilities';

export const mutations = {
    SET_ORGANIZATION_ID(state, id) {
        state.organization.id = id;
    },
    SET_LOGO(state, imageData) {
        state.uiElements.menuBar.components.logo.imageUrl = imageData;
    },
    SET_FAVICON(state, imageData) {
        setFavicon(imageData);
    },
    TOGGLE_MENU_PANEL(state, active) {
        state.uiElements[INTERFACE_PANEL_TRIGGERS.MENU].visible = active ?? !state.uiElements[INTERFACE_PANEL_TRIGGERS.MENU].visible;
    },
    CONFIGURE_PANELS(state, { search, table, legend, filter, measure, welcome, print, legendClose, startedFromPortal, isWebFeedbackPointGeometryOnly }) {
        const showLargeNavBar = startedFromPortal && state.uiElements.menuBar.components.logo.visible;

        state.uiElements[INTERFACE_PANEL_TRIGGERS.MENU].components.legend.visible = legend;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.MENU].components.filter.visible = filter && !showLargeNavBar;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.MENU].components.measure.visible = measure;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.MENU].components.welcome.visible = welcome;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.MENU].components.print.visible = print;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.MENU].components.legend.close.visible = legendClose;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.MENU].components.accessibility.visible = true;

        state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].visible = table;

        state.uiElements.menuBar.components.hamburger.visible = legend || measure || print;
        state.uiElements.menuBar.components.mapControls.components.search.visible = search;
        state.uiElements.menuBar.components.mapControls.components.filter.visible = filter;

        // Show the drawing toolbar only for a web 'meldingenkaart' that contains line/polygon geometry
        state.uiElements[INTERFACE_PANEL_TRIGGERS.WEB_FEEDBACK].showDrawToolbar = isWebFeedbackPointGeometryOnly;

    },
    TOGGLE_OBJECT_DETAIL_PANEL(state, active) {
        const currentState = state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].components.detailPanel.visible;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].components.detailPanel.visible = active ?? !currentState;
    },
    TOGGLE_FILTER_PANEL(state, active) {
        const currentState = state.uiElements[INTERFACE_PANEL_TRIGGERS.FILTERS].visible;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.FILTERS].visible = active ?? !currentState;
    },
    TOGGLE_LEGEND_PANEL(state, active) {
        const currentState = state.uiElements[INTERFACE_PANEL_TRIGGERS.LEGEND].visible;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.LEGEND].visible = active ?? !currentState;
    },
    TOGGLE_ADVANCED_SEARCH_PANEL(state, active) {
        state.uiElements[INTERFACE_PANEL_TRIGGERS.ADVANCED_SEARCH].visible = active ?? !state.uiElements[INTERFACE_PANEL_TRIGGERS.ADVANCED_SEARCH].visible;
    },
    SET_USERSEARCH_FILTER_DATA(state, filter) {
        state.uiElements[INTERFACE_PANEL_TRIGGERS.ADVANCED_SEARCH].components.filter = filter;
    },
    UPDATE_NAVBAR_SEARCH_RESULTS(state, { searchResults, searchText }) {
        // ignore if searchtext has changed during request to server
        if (searchText === state.uiElements.menuBar.components.mapControls.components.search.textToSearch) {
            const hasResults = (
                searchResults.addresses.length > 0 ||
                searchResults.webthemes.length > 0
            );
            state.uiElements.menuBar.components.mapControls.components.search.showResults = hasResults;
            state.uiElements.menuBar.components.mapControls.components.search.suggestions = hasResults ? searchResults : null;
        }
    },
    SHOW_MENU_FEEDBACK(state, { active, contentTypeId, data, mode }) {
        const element = state.uiElements[INTERFACE_PANEL_TRIGGERS.FEEDBACK_EDIT];
        const currentState = element.visible;
        const show = active ?? !currentState;
        element.mode = mode;
        element.data = data;
        element.contentTypeId = contentTypeId;
        element.visible = show;
    },
    TOGGLE_MENU_WEB_FEEDBACK(state, { active, data, showDrawToolbar }) {
        const element = state.uiElements[INTERFACE_PANEL_TRIGGERS.WEB_FEEDBACK];
        const currentState = element.visible;
        const show = active ?? !currentState;
        element.data = data;
        element.visible = show;
        element.showDrawToolbar = showDrawToolbar;
    },
    TOGGLE_MENU_WEB_INFORMATION(state, { active, data }) {
        const element = state.uiElements[INTERFACE_PANEL_TRIGGERS.WEB_INFORMATION];
        const currentState = element.visible;
        const show = active ?? !currentState;
        element.data = data;
        element.visible = show;
    },
    NEDGLOBE_MOBILE_TOGGLE_INFOPANEL(state, visible) {
        state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].visible = visible ?? !state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].visible;
    },
    NEDGLOBE_MOBILE_TOGGLE_FOCUS_INFOPANEL(state, focus) {
        state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].focus = focus ?? !state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].focus;
    },
    NEDGLOBE_MOBILE_DISPLAY_SELECTION_START(state) {
        state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].loading = true;
    },
    NEDGLOBE_MOBILE_DISPLAY_SELECTION_END(state) {
        state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].loading = false;
    },
    TOGGLE_NAVBAR_HAMBURGER_BUTTON(state, active) {
        const currentState = state.uiElements.menuBar.components.hamburger.visible;
        state.uiElements.menuBar.components.hamburger.visible = active ?? !currentState;
    },
    SET_NAVBAR_PREVIOUS_TITLE(state, { label, title }) {
        state.uiElements.menuBar.components.previous.label = label;
        state.uiElements.menuBar.components.previous.title = title;
    },
    UPDATE_SEARCH_SEARCHTEXT(state, { searchText }) {
        state.uiElements.menuBar.components.mapControls.components.search.textToSearch = searchText;
    },
    CLEAR_NAVBAR_SEARCH_RESULTS(state) {
        state.uiElements.menuBar.components.mapControls.components.search.showResults = false;
        state.uiElements.menuBar.components.mapControls.components.search.textToSearch = '';
        state.uiElements.menuBar.components.mapControls.components.search.suggestions = null;
    },
    TOGGLE_SEARCH_RESULTS(state, active) {
        state.uiElements.menuBar.components.mapControls.components.search.showResults = active ?? !state.uiElements.menuBar.components.mapControls.components.search.showResults;
    },
    UPDATE_INFORMATION_PANEL(state, { height, width, maxWidth }) {
        if (!height) {
            height = (window.innerHeight * INFOTABLE_HEIGHT_PERC) / 100;
        }
        if (!width) {
            width = (window.innerWidth * INFOTABLE_WIDTH_PERC) / 100;
        }
        if (!maxWidth) {
            state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].width = width;
        }
        state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].height = height;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].maxWidth = maxWidth;
    },
    UPDATE_STYLE_PANELS(state, resize) {
        state.uiElements[INTERFACE_PANEL_TRIGGERS.BASELAYER].resize = resize;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].components.detailPanel.resize = resize;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.LEGEND].resize = resize;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.MENU].resize = resize;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.FILTERS].resize = resize;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.ADVANCED_SEARCH].resize = resize;
    },
    TOGGLE_WELCOME_PANEL(state, { active, data }) {
        // show or delete welcome panel
        // As no parameters are given, toggle the variable visible
        // otherwise give visible the value of the parameter 'active' (true or false)
        const currentState = state.uiElements[INTERFACE_PANEL_TRIGGERS.WELCOME_PANEL].visible;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.WELCOME_PANEL].visible = active ?? !currentState;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.WELCOME_PANEL].data = data;
    },
    UPDATE_WELCOME_PANEL(state, dontShowAgain) {
        state.uiElements[INTERFACE_PANEL_TRIGGERS.WELCOME_PANEL].dontShowAgain = dontShowAgain;
        // immediately save this in the LOCAL_STORAGE
        const webThemeId = state.webTheme.id;
        const panelsData = {
            dontShowWelcomePanel: dontShowAgain
        };
        localStorage.setItem(`${LOCAL_STORAGE_KEYS.UIELEMENTS}-${webThemeId}`, JSON.stringify(panelsData));
    },
    SET_CLICKED_IN_RANGE_FOR_WEBFEEDBACK(state, value) {
        state.clickedInRangeForWebfeedback = value;
    },
    WEB_MAP_MOVE_END(state) {
        // Check if we need to save the webtheme viewport
        if (state.webTheme.data?.saveViewport) {
            // If so store in localstorage with name: VIEWPORT-{ID}
            const viewportZoom = state.defaultMap.viewport?.zoom;
            const viewportCenter = state.defaultMap.viewport?.center;
            const webThemeId = state.webTheme.id;
            if (viewportZoom && viewportCenter) {
                const viewportData = {
                    center: viewportCenter,
                    zoom: viewportZoom,
                };
                localStorage.setItem(`${LOCAL_STORAGE_KEYS.VIEWPORT}-${webThemeId}`, JSON.stringify(viewportData));
            }
        }
    },
    SET_HEIGHT_MENU_WEB_INFORMATION(state, height) {
        state.uiElements[INTERFACE_PANEL_TRIGGERS.WEB_INFORMATION].height = height;
    },
    SET_HEIGHT_AND_WIDTH_MENU_ADVANCED_SEARCH(state, { height, width }) {
        state.uiElements[INTERFACE_PANEL_TRIGGERS.ADVANCED_SEARCH].height = height;
        state.uiElements[INTERFACE_PANEL_TRIGGERS.ADVANCED_SEARCH].width = width;
    },
    SET_SCALES(state, { scales }) {
        state.scales = scales;
    }
};
